var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6611 11.2757V13.2749C14.6619 13.4605 14.6238 13.6442 14.5495 13.8143C14.4751 13.9844 14.3661 14.137 14.2293 14.2625C14.0926 14.3879 13.9311 14.4835 13.7553 14.5429C13.5795 14.6024 13.3932 14.6245 13.2083 14.6078C11.1577 14.3849 9.18785 13.6842 7.45718 12.5619C5.84701 11.5387 4.48187 10.1736 3.45871 8.5634C2.33245 6.82487 1.63156 4.84548 1.41282 2.78561C1.39617 2.60132 1.41807 2.41559 1.47713 2.24023C1.53619 2.06487 1.63112 1.90374 1.75587 1.76708C1.88061 1.63042 2.03245 1.52123 2.20171 1.44647C2.37097 1.3717 2.55394 1.333 2.73898 1.33283H4.73822C5.06163 1.32965 5.37517 1.44417 5.62039 1.65506C5.86561 1.86595 6.02578 2.15881 6.07104 2.47906C6.15542 3.11886 6.31192 3.74706 6.53753 4.35168C6.62719 4.5902 6.6466 4.84943 6.59345 5.09865C6.5403 5.34786 6.41682 5.57662 6.23764 5.75781L5.3913 6.60415C6.33998 8.27254 7.72138 9.65395 9.38978 10.6026L10.2361 9.75628C10.4173 9.57711 10.6461 9.45363 10.8953 9.40048C11.1445 9.34733 11.4037 9.36674 11.6422 9.4564C12.2469 9.68201 12.8751 9.8385 13.5149 9.92289C13.8386 9.96855 14.1342 10.1316 14.3456 10.381C14.5569 10.6305 14.6692 10.9489 14.6611 11.2757Z",
    stroke: "#6A7282",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9939,
    height: 15.9939,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.583ceff065a5f8c28c2c08ea27e457bb.svg";
export { ForwardRef as ReactComponent };